import { createSelector } from 'reselect';
import get from 'lodash/get';

export const getPagination = (state) => get(state, 'reports.depreciation.pagination', {});

export const getFilters = (state) => get(state, 'reports.depreciation.filters', {});

export const getNeedFetch = (state) => get(state, 'reports.depreciation.needFetch', false);

export const getIsLoading = (state) => get(state, 'reports.depreciation.isLoading', false);

export const getAssets = (state) => get(state, 'reports.depreciation.entities.assets', {});
export const getAssetsIds = (state) => get(state, 'reports.depreciation.result.assets', []);

export const getVisibleAssets = createSelector([getAssetsIds, getAssets], (ids, assets) =>
  ids.map((id) => assets[id])
);



// WEBPACK FOOTER //
// src/selectors/reports_depreciation.js